import { MapPin } from 'lucide-react';
import { PageHeader } from '@/components/common/page-header';
import { EmptyState, ErrorState, LoadingRows } from '@/components/common/states';
import { AllBookmarks } from '@/components/movie/bookmarks';
import { useBookmarks } from '@/hooks/use-library';

export function BookmarksPage() {
  const bookmarks = useBookmarks();
  return (
    <div className="space-y-6">
      <PageHeader title="Bookmarks" description="Moments inside videos, newest first. Press B while a movie plays to add one; open one to play from there." />
      {bookmarks.isPending ? (
        <LoadingRows rows={4} />
      ) : bookmarks.isError ? (
        <ErrorState error={bookmarks.error} onRetry={() => void bookmarks.refetch()} />
      ) : bookmarks.data.bookmarks.length === 0 ? (
        <EmptyState title="No bookmarks yet" description="Press B, or the Bookmark button under the player, to mark the moment on screen." icon={<MapPin className="size-5" />} />
      ) : (
        <AllBookmarks bookmarks={bookmarks.data.bookmarks} />
      )}
    </div>
  );
}
